import { useEffect } from "react";
import "./BottomTabs.css";

/**
 * 하단 탭바.
 *
 * 칸은 앱에 실제로 있는 화면만 둔다. 시안에는 '기록' 과 '마이' 가 따로
 * 있었지만 지금 둘 다 내 행성 한 화면이어서, 칸만 늘리면 눌러도 같은 곳이
 * 나온다. 그 화면들이 따로 생기면 그때 칸을 늘린다.
 *
 * 가운데 행성은 '내 행성' 이다. 이 앱에서 가장 자주 돌아오는 자리라
 * 엄지가 닿기 좋은 가운데에 크게 둔다.
 */
const TABS = [
  { key: "home", icon: "🏠", label: "홈" },
  { key: "friends", icon: "🔭", label: "다른 행성" },
  { key: "mine", icon: "🪐", label: "내 행성", big: true },
  { key: "trail", icon: "🚀", label: "우주 궤적" },
];

export default function BottomTabs({ active, onSelect }) {
  /* 사파리에서는 아래 주소창이 접혔다 펴지며 '화면 아래' 가 움직인다.
     position:fixed 는 문서 기준이라, 주소창이 걸쳐 있는 만큼 막대가 내용
     한가운데에 떠 보였다. 실제로 보이는 영역만큼 끌어올린다.
     visualViewport 가 없는 브라우저에서는 0 이라 지금과 같다. */
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const set = () => {
      const gap = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
      document.documentElement.style.setProperty("--tabbar-shift", `${gap}px`);
    };
    set();
    vv.addEventListener("resize", set);
    vv.addEventListener("scroll", set);
    return () => {
      vv.removeEventListener("resize", set);
      vv.removeEventListener("scroll", set);
      document.documentElement.style.removeProperty("--tabbar-shift");
    };
  }, []);

  return (
    <nav className="tabbar" aria-label="아래 이동 막대">
      {TABS.map((t) => (
        <button
          key={t.key}
          className={`tabbar-item${t.big ? " tabbar-big" : ""}${active === t.key ? " on" : ""}`}
          onClick={() => onSelect(t.key)}
          aria-current={active === t.key ? "page" : undefined}
        >
          <span className="tabbar-ic" aria-hidden="true">{t.icon}</span>
          <span className="tabbar-label">{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
